module.exports = __webpack_public_path__ + "static/media/marker_off.8d8bfffb.svg";